// extracted by mini-css-extract-plugin
export default {"wrapper":"SideNav_wrapper__nxH4F","heading":"SideNav_heading__+r3QX","tabs":"SideNav_tabs__5rYxP"};